module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0058.jpg?v=70c426a6";